export enum OrderTabsNames {
    COMMENTS = "Komentarze",
    DETAILS = "Szczegóły zamówienia",
    HISTORY = "Historia",
    ADDITIONAL_INFO = "Informacje dodatkowe",
    SMS_HISTORY = "Wysłane wiadomości"
}